import { Scale } from 'lucide-react';
import SalikFuelPredictor from './compliance/SalikFuelPredictor';
import CustomsHazmatLocker from './compliance/CustomsHazmatLocker';
import BillingContractLedger from './compliance/BillingContractLedger';

export default function ComplianceFinance() {
  return (
    <section aria-label="Compliance and finance" className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-50 ring-1 ring-emerald-500/30">
              <Scale className="h-4 w-4 text-emerald-700" strokeWidth={1.75} />
            </div>
            <span className="text-xs font-semibold uppercase tracking-widest text-emerald-700/80">
              Regulatory &amp; Commercial
            </span>
          </div>
          <h2 className="text-xl font-bold tracking-tight text-logi-text sm:text-2xl">
            Compliance &amp; Finance
          </h2>
          <p className="mt-1 text-sm text-logi-muted">
            Salik AI · UAE customs · B2B billing automation
          </p>
        </div>
      </div>

      <SalikFuelPredictor />

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
        <CustomsHazmatLocker />
      </div>

      <BillingContractLedger />
    </section>
  );
}
